/** `client.messageTemplates` (#1310): the front desk reads and edits the booking confirmation text. */
export class MessageTemplatesClient {
    request;
    constructor(request) {
        this.request = request;
    }
    base(slug) {
        return `/v1/sites/${encodeURIComponent(slug)}/message-templates`;
    }
    /** Staff who manage bookings. */
    async list(slug) {
        const res = await this.request("GET", this.base(slug), undefined, true);
        return res.templates;
    }
    /** Owners and managers. 400 on an unknown placeholder or a body over 480 characters. */
    update(slug, key, input) {
        return this.request("PUT", `${this.base(slug)}/${encodeURIComponent(key)}`, input, true);
    }
}
//# sourceMappingURL=messageTemplates.js.map